import P3Regular from 'components/typography/P3Regular';
import { RevisionTemplateRow } from 'components/tables/data/revision-template/types';

/**
 * Column for the revision template id.
 */
export default function RevisionTemplateIdColumn({ data: { revisionTemplateId } }: { data: RevisionTemplateRow }) {
  return <P3Regular color="gray.8">{revisionTemplateId}</P3Regular>;
}
